export const EquipmentInvoiceLineType = {
  PURCHASE: 'PURCHASE',
  LEASE: 'LEASE',
  ASSISTANCE: 'ASSISTANCE',
  ADDITIONAL_COST: 'ADDITIONAL_COST'
};
